import { render, staticRenderFns } from "./StartupCostsOverTime.vue?vue&type=template&id=52271ce6"
import script from "./StartupCostsOverTime.vue?vue&type=script&lang=js"
export * from "./StartupCostsOverTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports